import { Option } from "@/type/Common.ts";

export const enum BusinessTypeEnum {
    KECO = "KECO",
    SEOUL = "SEOUL",
    BRAND = "BRAND",
    SEOUL_PUBLIC = "SEOUL_PUBLIC",
}

export const BusinessTypeLabel: Record<BusinessTypeEnum, string> = {
    KECO: "환경부",
    SEOUL: "서울시",
    BRAND: "브랜드",
    SEOUL_PUBLIC: "서울시 공영",
};

export const BusinessTypeOptions: Option<BusinessTypeEnum>[] = [
    { label: BusinessTypeLabel.KECO, value: BusinessTypeEnum.KECO },
    { label: BusinessTypeLabel.SEOUL, value: BusinessTypeEnum.SEOUL },
    { label: BusinessTypeLabel.BRAND, value: BusinessTypeEnum.BRAND },
    { label: BusinessTypeLabel.SEOUL_PUBLIC, value: BusinessTypeEnum.SEOUL_PUBLIC },
];